export function retryFunc<T>(
  func: () => Promise<T>,
  maxRetries: number,
  delay: number,
): Promise<T> {
  return new Promise((resolve, reject) => {
    let retries = 0;
    let error = new Error('Exceeded maximum retries');

    async function attempt() {
      try {
        const res = await func();
        if (res) {
          resolve(res);
        } else if (retries < maxRetries) {
          retries += 1;
          setTimeout(attempt, delay);
        } else {
          reject(error);
        }
      } catch (err) {
        error = err as Error;
        if (retries < maxRetries) {
          retries += 1;
          setTimeout(attempt, delay);
        } else {
          reject(error);
        }
      }
    }

    attempt();
  });
}
